module.exports = __webpack_public_path__ + "static/media/logo.246ac62d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 1361
// module chunks = 8